import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
  Inject,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { Title } from "@angular/platform-browser";
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  EventType,
} from "@angular/router";
import { filter, map, takeUntil } from "rxjs/operators";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { provideHttpClient } from "@angular/common/http";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  EventMessage,
  InteractionStatus,
  RedirectRequest,
} from "@azure/msal-browser";
import { AuthenticationService } from "./core/security/authentication.service";

/**
 * Component
 */
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Angular - MSAL Example";
  loginDisplay = false;
  tokenExpiration: string = "";
  private readonly _destroying$ = new Subject<void>();

  /**
   * Router outlet
   */
  @ViewChild("outlet", { static: false }) outlet: any;

  showLoading = true;
  /**
   * Creates an instance of app component.
   */
  public constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private msalAuthService: AuthenticationService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  async ngOnInit() {
    // Change tab title on route
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    // Used for storing and displaying token expiration
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === "msal:acquireTokenSuccess"
        )
      )
      .subscribe((msg) => {
        this.tokenExpiration = (msg.payload as any).expiresOn;
        localStorage.setItem("tokenExpiration", this.tokenExpiration);
      });

    const appTitle = this.titleService.getTitle();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          if (child.snapshot.data["title"]) {
            return child.snapshot.data["title"];
          }
          return appTitle;
        })
      )
      .subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });
  }
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

    // Log the user out
  logout() {
    this.authService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  /**
   * Determines whether activate on
   */
  onActivate() {
    this.showLoading = false;
  }
}
